// The last seat counts the Worker sent back, for the banner to read (spec §5.4).
import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { PresenceCounts } from "../api/types";

export interface PresenceContextValue {
  counts: PresenceCounts | null;
  setCounts: (c: PresenceCounts) => void;
}

export const PresenceContext = createContext<PresenceContextValue | null>(null);

export function PresenceProvider({ children }: { children: ReactNode }): JSX.Element {
  const [counts, setCounts] = useState<PresenceCounts | null>(null);
  const value = useMemo(() => ({ counts, setCounts }), [counts]);
  return <PresenceContext.Provider value={value}>{children}</PresenceContext.Provider>;
}

/** Null until the first beat comes back — and outside the provider. */
export function usePresence(): PresenceCounts | null {
  const ctx = useContext(PresenceContext);
  return ctx?.counts ?? null;
}
